<template>
    <tr id="row">
      <td>
        <div class="row1 d-flex flex-column align-items-start justify-content-center">
          <div class="lg1">
            <span class="category">{{category.lg1}}</span> <span class="type">{{type.lg1}}</span>
          </div>
        </div>
        <div class="row2 lg2">
          <span class="category">{{category.lg2}}</span > <span class="type">{{type.lg2}}</span>
        </div>
      </td>
      <td>
        <div class="price d-flex align-items-center justify-content-end">{{price}}</div>
      </td>
    </tr>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV2RatesRow',
  props: {
    ratesLg: Object,
  },
  computed: {
    category () {
      return {lg1: this.ratesLg.lg1[0].catroom_label, lg2: this.ratesLg.lg2[0].catroom_label}
    },
    type () {
      return {lg1: this.ratesLg.lg1[0].label_value, lg2: this.ratesLg.lg2[0].label_value}
    },
    price () {
      return this.ratesLg.lg1[0].mrr_value
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure2021.scss";

tr {
  border-bottom: 1px solid $grey;

  &:last-of-type {
    border-bottom: none;
  }

  td:nth-of-type(1) {
    @include widthPercent(726);
  }

  td:nth-of-type(2) {
    @include widthPercent(214);
  }

  .row1 {
    height: 100%;
    @include heightPercent(50);
    @include widthPercent(726);

    .lg1 {
      max-height: 2rem;
      overflow: hidden;

      .category {
        font-family: "Spectral-Italic";
        @include fontSize(39);
        line-height: 1.2em;;
      }

      .type {
        font-family: "Spectral-Italic";
        @include fontSize(32);
        line-height: 1.2em;
      }
    }
  }

  .row2 {
    overflow: hidden;
    @include heightPercent(50);

    .category { 
      font-family: "Montserrat-Regular";
      @include fontSize(36);
      line-height: 1.2em;
    }

    .type {
      font-family: "Montserrat-Regular";
      @include fontSize(36);
      line-height: 1.2em;
    }
  }

  .price {
    font-family: "Montserrat-Regular";
    height: 100%;
    @include fontSize(36);
    color: $grey;
    white-space: nowrap;
    border-left: 1px solid $grey;
    //@include widthPercent(214);
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v2/rates/rowRates.vue